module.exports = __webpack_public_path__ + "static/img/rolling.079bdaf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-login-2018/rolling.gif
// module id = 713
// module chunks = 1